<template>
  <section class="bg-[#2262AD] mb-5">
    <div class="bg-hero h-[75vh]">
      <div class="container flex items-center h-full">
        <div class="w-full">
          <div class="mb-16">
            <h1
              class="md:text-6xl text-3xl text-white flex items-start flex-wrap tracking-wider mb-7"
            >
              <span class="text-nowrap">
                {{ t("hero_section.best_travel") }}
              </span>
              <span class="text-[#F78248] inline-block tracking-wider relative"
                ><span>{{ t("hero_section.experience") }}</span>
                <span
                  class="h-5 bg-[url('/assets/images/Vector.svg')] w-full inline-block bg-no-repeat absolute -bottom-5 left-0"
                ></span>
              </span>
            </h1>
            <p class="text-white">
              {{ t("hero_section.experience_the_various_exciting_tours") }}
            </p>
          </div>
          <div
            class="md:w-2/3 mx-auto bg-white rounded md:p-5 p-3 flex items-center md:gap-3 gap-2 minsmart:text-sm"
          >
            <span class="md:text-2xl text-lg">
              <font-awesome :icon="['fas', 'location-dot']" />
            </span>
            <label class="w-full">
              <span>{{
                t("hero_section.search_for_destinations_months_continent")
              }}</span>
              <input
                type="text"
                v-model="search"
                class="w-full border-none focus:outline-none text-[#697488]"
                :placeholder="t('hero_section.ie_asia')"
              />
            </label>
            <div class="flex gap-2">
              <UIButton
                class="bg-[#13357B] text-white md:px-4 px-3 md:py-3 py-2 rounded-md"
                @click="openFilters"
              >
                <span>
                  <font-awesome :icon="['fas', 'filter']" />
                </span>
                <span v-if="activeFilterCount > 0" class="ml-1">
                  ({{ activeFilterCount }})
                </span>
              </UIButton>
              <div class="md:w-auto w-16">
                <UIButton class="bg-[#13357B] md:px-6 px-3 md:py-3 py-2 rounded-md" @click="navigateToSearch">
                  <span class="inline-block scale-125 md:mr-2 mr-1">
                    <font-awesome :icon="['fas', 'magnifying-glass']" />
                  </span>
                  <span class="md:inline hidden">{{ t("hero_section.search") }}</span>
                </UIButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <h3 class="text-4xl text-[#13357B] font-bold" v-if="name">
    {{ t("hero_section.welcome") }} {{ name }}.
  </h3>
</template>

<script setup lang="ts">
import type { TripFilters } from "~/types/filter";

const props = defineProps<{
  filters?: TripFilters;
}>();

const emit = defineEmits<{
  "update:filters": [filters: TripFilters];
  "open-filters": [];
}>();

const { t } = useI18n();
const localPath = useLocalePath();
const name = useState<string | null>("name", () => null);
const cookieName = useCookie("name");
name.value = cookieName.value;
const search = ref("");

const activeFilterCount = computed(() => {
  if (!props.filters) return 0;
  let count = 0;
  if (props.filters.minPrice != null || props.filters.maxPrice != null) count++;
  if (props.filters.minDays != null || props.filters.maxDays != null) count++;
  if (props.filters.continentIds && props.filters.continentIds.length > 0) count++;
  if (props.filters.monthIds && props.filters.monthIds.length > 0) count++;
  return count;
});

function navigateToSearch() {
  navigateTo(localPath(`/search-page/${search.value}`));
}

function openFilters() {
  emit("open-filters");
}
</script>
<style scoped>
.bg-hero {
  background-image: url(/assets/images/images.png);
  background-position: right top;
  background-size: contain;
  background-repeat: no-repeat;
}
h1 {
  text-shadow: 1px 0 #fff, -1px 0 #fff, 0 1px #fff, 0 -1px #fff, 1px 1px #fff,
    -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;
}
</style>
